import "../Static Files/styles/home page/home.css";

const FollowUs = () => {
  return (
    <>
      <div className="followus-small-div">
        <ul>
          <li>
            <a target="_blank" href="https://www.instagram.com/joyfultravel.az/">
              <i class="fa-brands fa-instagram"></i>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://wa.me/994555074499">
              <i class="fa-brands fa-whatsapp"></i>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.facebook.com/joyful.travel.baku">
              <i class="fa-brands fa-facebook"></i>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.tiktok.com/@joyfultravel.az?_t=ZS-8v5UVd7lYiA&_r=1">
              <i class="fa-brands fa-tiktok"></i>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default FollowUs;
